import { Grid2 } from '@mui/material'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons/toggle-button'
import { FileAccordion } from 'components/FileAccordion/FileAccordion'
import { useAuthStore } from 'context/AuthStore'
import { useContractStore } from 'context/ContractStore'
import { ACCOUNTANT, MANAGER } from 'lib/constants/roles'
import { memo, useState } from 'react'

const fileTypes = role => {
  const files = [
    { label: 'Файлы клиента', code: 'client-files' },
    { label: 'Файлы залога', code: 'pledge-files' },
    { label: 'Файлы МФО', code: 'bank-files' },
    { label: 'Файлы wings', code: 'wings-files' },
    { label: 'Ручное подписание', code: 'manual-signing' }
  ]

  if (role === MANAGER) {
    return [
      { label: 'Файлы клиента', code: 'client-files' },
      { label: 'Файлы залога', code: 'pledge-files' },
      { label: 'Файлы МФО', code: 'bank-files' }
    ]
  }

  return files
}

const getBankDocs = (data, role) => {
  if (!data?.files) {
    return []
  }

  let bankDocs = data.files.filter(
    file => ['userUploadClientBankDocs'].includes(file?.category.step) && file.category.code !== 'PF_ZIP'
  )

  if (role === MANAGER) {
    bankDocs = bankDocs.concat(data.files.filter(file => ['PP'].includes(file?.category.code)))
  }

  return bankDocs
}

export const FilesTab = memo(({ readonly = false }) => {
  const { authStore } = useAuthStore()

  const {
    contractStore: { loanApplicationData }
  } = useContractStore()

  const [activeTab, setActiveTab] = useState(fileTypes(authStore?.isUserRole)?.[0]?.code)

  const clientDocs = loanApplicationData?.files?.filter(
    file =>
      ['userCreateLoanApplication', 'userRevert'].includes(file?.category?.step) && file?.collateralClientId === null
  )

  const pledgeDocs = loanApplicationData?.files?.filter(file =>
    ['userUploadCollateralDocs'].includes(file?.category?.step)
  )

  const bankDocs = getBankDocs(loanApplicationData, authStore?.isUserRole)
  const wingsDocs = loanApplicationData?.files?.filter(file => file?.category?.step === 'wings')
  const manualSigningDocs = loanApplicationData?.files?.filter(file => file?.category?.step === 'userManualSigning')

  return (
    <>
      <Grid2
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none!important'
          },
          gap: '10px'
        }}
      >
        <AsterToggleButtonGroup
          exclusive
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val)
          }}
        >
          {fileTypes(authStore?.isUserRole).map(({ label, code }, i) => (
            <AsterToggleButton key={`table-toggle-btn-${code}`} value={code}>
              {label}
            </AsterToggleButton>
          ))}
        </AsterToggleButtonGroup>
      </Grid2>

      {activeTab === 'client-files' && (
        <FileAccordion title="Клиент" data={clientDocs || []} isEdit="client-files" readonly={readonly} />
      )}

      {activeTab === 'pledge-files' && <FileAccordion title="Залог" data={pledgeDocs || []} />}
      {activeTab === 'bank-files' && <FileAccordion title="Банк" data={bankDocs || []} />}
      {activeTab === 'wings-files' && <FileAccordion title="Wings" data={wingsDocs || []} />}
      {activeTab === 'manual-signing' && <FileAccordion title="Ручное подписание" data={manualSigningDocs || []} />}
    </>
  )
})
